import { mapActions } from "vuex";

export default  {
	created () {    
	},
	methods: 
    {
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'registroOrdenFtn':
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_orden', 
									tablaPost: ['examen_diagnosticos','info_orden','info_ventas'],
									tablaAuditar: true
								 }
							 }) 
						break;
						case 'recibidoOrdenFtn':
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_recibido', 
									tablaPost: ['info_orden']
								 }
							 })
						break;
						case 'abonosFtn':
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_abono', 
									tablaPost: ['info_ventas']
								 }
							 }) 
							let saldo = this.dataForm[this.namePath].info_ventas.saldo - this.dataForm[this.namePath].info_ventas.abono
							if(saldo<0)
							{
								saldo = 0
								await this.updateDataForm({state: 'info_ventas/abono', data: this.dataForm[this.namePath].info_ventas.saldo})
							}
							await this.updateDataForm({state: 'info_ventas/saldo', data: saldo})
						break;
						case 'entregaFtn':
							
							await this.updateDataForm({state: 'info_orden/estado', data: 'entregado'})
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_entrega', 
									tablaPost: ['info_orden']
								 }
							 })
						break;

					}
				}
				let data_backend= await this.save(event.save)

				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'registroOrdenFtn':
							window.open(this.url+"/api/pdf/orden_venta?id="+data_backend['ids']['id_info_orden']+"&token="+this.token, "_blank");						
							window.open(this.url+"/api/pdf/diagnosticos?id="+data_backend['ids']['id_info_examens']+"&token="+this.token, "_blank")

							await this.updateDataGet({ index: this.indexData, state: 'info_orden', data: this.dataForm[this.namePath].info_orden})
							await this.updateDataGet({ index: this.indexData, state: 'info_ventas', data: this.dataForm[this.namePath].info_ventas})
							await this.updateDataGet({ index: this.indexData, state: 'examen_diagnosticos', data: this.dataForm[this.namePath].examen_diagnosticos})						
						break;
						case 'recibidoOrdenFtn':
							this.updateDataGet({state: 'info_orden',index: this.indexData, data: this.dataForm[this.namePath].info_orden})						
						break;
						case 'abonosFtn':
							this.updateDataGet({state: 'info_ventas',index: this.indexData, data: this.dataForm[this.namePath].info_ventas})						
						break;
						case 'entregaFtn':
							this.spliceDataGet(this.indexData)						
						break;
					}
				}
				
				await this.resetGlobal({state: 'indexData'}) 								
				await this.resetGlobal({state: 'openModal'}) 
				await this.resetDataForm()
				
				return true
			}
			catch{

			}			
		}		
	},
}
